<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="printPreviewModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" style="z-index:1000000000">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" v-if="link">
                    <div class="modal-header" v-if="1 == 0">
                        <h5 class="modal-title">Impressão</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-loading class="my-3" msg="Aguarde..." v-if="!iframe_src" />
                        
                        <!-- embed-responsive-21by9 -->
                        <div class="embed-responsive embed-responsive embed-responsive-4by3" v-if="iframe_src" v-show="false">
                          <iframe id="pdf-print-preview" 
                            class="embed-responsive-item" 
                            :src="iframe_src" 
                            @load="confirmar()" 
                            @afterprint="fechar()" />
                        </div>
                    </div>
                    <div class="modal-footer" v-if="1 == 0">
                        <button type="button" class="btn btn-success" @click="confirmar()">Imprimir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() { 
        return { 
            link: "",
            iframe_src: "",
            mobile_checker: false
        }
    },

    components: { 
        AzLoading,
    },

    methods: { 
        confirmar() { 
            this.$nextTick(() => { 
                setTimeout(() => { 
                    $('#printPreviewModal').modal('hide');
                }, 1000);
                
                $('#printPreviewModal').modal('hide');
            });

            $('#printPreviewModal').modal('hide');    

            console.log('imprimindo...');

            let id = 'pdf-print-preview';
            var iframe = document.frames ? document.frames[id] : document.getElementById(id);
            var ifWin = iframe.contentWindow || iframe;

            try { 
                iframe.focus();
                ifWin.focus(); 
                ifWin.print();
            } catch (e) { 
                this.$toast.add({
                    severity: 'error',
                    summary: "Atenção",
                    detail: "Falha na abertura da impressão. \n" + ( e.message ? e.message : '' ),
                    life: 5000
                });

                console.log(e);
                window.open(iframe.src, '_blank');
            }
            
            return false;
        },

        fechar() { 
            $('#printPreviewModal').modal('hide');

            this.iframe_src = null;
            this.link = null;
        },

        tratar_retorno_impressao (response) { 

            if ( response.response && response.response.status >= 400 ) { 
                let string = new TextDecoder().decode(response.response.data);
                let retorno = JSON.parse(string);
                let msg = ( retorno && retorno.message ) ? retorno.message : ( retorno.msg ? retorno : 'Falha na impressão.' );
                
                this.$toast.add({
                    severity: 'error',
                    summary: "Atenção",
                    detail: msg,
                    life: 3000
                });
            } 

            if(response.headers && response.headers["content-type"] == "application/json") {

                // let uint8array = new TextEncoder("utf-8").encode("Plain Text");
                let string = new TextDecoder().decode(response.data);
                let obj = JSON.parse(string);

                if ( obj && obj.openlink ) { 

                    let janela = window.open(obj.openlink, '_blank')
                    
                    if ( janela ) { 
                        
                        janela.focus();
                    
                        this.$toast.add({
                            severity: 'success',
                            summary: "Atenção",
                            detail: 'Link: ' + obj.openlink,
                            life: 3000
                        });

                    } else { 

                        this.$toast.add({
                            severity: 'success',
                            summary: "Atenção",
                            detail: 'Não foi possível abrir o arquivo. Verifique se há bloqueador de pop-up ativado. Link: ' + obj.openlink,
                            life: 3000
                        });

                    }

                } else if ( obj && obj.openlinks ) { 

                    obj.openlinks.forEach(link => {
                        window.open(link, '_blank').focus();
                    });

                    this.$toast.add({
                        severity: 'success',
                        summary: "Atenção",
                        detail: 'Arquivos abertos: ' + obj.openlinks.length,
                        life: 3000
                    });

                } else { 

                    let msg = ( obj && obj.message ) ? obj.message : ( obj.msg ? obj.msg : '' );

                    this.$toast.add({
                        severity: ( obj && obj.status_code >= 400 ) ? 'error' : 'success',
                        summary: "Atenção",
                        detail: msg ? msg : 'Etiqueta enviada para o servidor de impressão.',
                        life: 3000
                    });

                }

                this.$nextTick(() => { 
                    setTimeout(() => { 
                        $('#printPreviewModal').modal('hide');
                    }, 1000);
                    
                    $('#printPreviewModal').modal('hide');
                });

                $('#printPreviewModal').modal('hide');    

            } else {

                let blob = new Blob([response.data], { type: 'application/pdf' }),
                    url = window.URL.createObjectURL(blob)

                var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                if(this.$util.check_mobile_device()) {

                    var downloadAnchorNode = document.createElement('a');
                    downloadAnchorNode.setAttribute("href", url);
                    downloadAnchorNode.setAttribute("download", "laudo.pdf");
                    document.body.appendChild(downloadAnchorNode); 
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();

                } else if (isSafari){
                    setTimeout(() => {
                        window.open(url, '_blank');
                    });

                    this.$nextTick(() => { 
                        setTimeout(() => { 
                            $('#printPreviewModal').modal('hide');
                        }, 1000);
                        
                        $('#printPreviewModal').modal('hide');
                    });
                } else {
                    this.iframe_src = url;
                }


            }

        },

        imprimir(link, pep = false, dados = null, querystring = false) { 
            this.iframe_src = null;
            this.link = link;

            if ( pep ) { 
                const papel = ( pep && this.$util.getCookie('page-size') ) ? this.$util.getCookie('page-size') : 'A4';

                const hasQueryString = link.indexOf('?') !== -1;

                link = link + (hasQueryString ? '&' : '?') + 'uo=' + this.$util.getCookie('id_unidade_operacao');

                if ( papel && !_.get(dados, 'papel') ) { 
                    link = link + '&papel=' + papel;
                }
                
            }

            this.$store.commit('loading', true);
            
            if(!this.$util.check_mobile_device()) {
                $('#printPreviewModal').modal('show');
            }

            const base = this.axios.defaults.baseURL;
            const redir = ( base.substr(0,5) == 'https' )
                ? ( 'https://api-relatorio.klingo.app/api'
                        + ( link.substr(0,1) == '/' ? '' : '/' ) ) 
                : '';

            //

            if ( dados && !querystring ) { 

                this.axios.post(redir + link, dados, {
                        data: {},
                        responseType: 'arraybuffer'
                    })
                    .then(response => {
                        this.tratar_retorno_impressao(response);
                        
                        /*
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            url = window.URL.createObjectURL(blob)

                        this.iframe_src = url;
                        */

                    })
                    .catch(error => { 
                        this.$toast.add({
                            severity: 'error',
                            summary: "Atenção",
                            detail: ( error.response && error.response.data ) ? error.response.data.message : error.message,
                            life: 3000
                        });

                        $('#printPreviewModal').modal('hide');
                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });

            } else { 

                if ( dados && querystring ) { 

                    link += ( pep ? '&' : '?' ) + $.param( dados );
                }
            
                this.axios.get(redir + link, {
                        data: {},
                        responseType: 'arraybuffer'
                    })
                    .then(response => {
                        this.tratar_retorno_impressao(response);

                        /*
                        if(response.headers && response.headers["content-type"] == "application/json") {

                            // let uint8array = new TextEncoder("utf-8").encode("Plain Text");
                            let string = new TextDecoder().decode(response.data);
                            let obj = JSON.parse(string);

                            if ( obj && obj.openlink ) { 

                                window.open(obj.openlink, '_blank').focus();

                                this.$toast.add({
                                    severity: 'success',
                                    summary: "Atenção",
                                    detail: 'Link: ' + obj.openlink,
                                    life: 3000
                                });

                            } else if ( obj && obj.openlinks ) { 

                                obj.openlinks.forEach(link => {
                                    window.open(link, '_blank').focus();
                                });

                                this.$toast.add({
                                    severity: 'success',
                                    summary: "Atenção",
                                    detail: 'Arquivos abertos: ' + obj.openlinks.length,
                                    life: 3000
                                });

                            } else { 

                                this.$toast.add({
                                    severity: 'success',
                                    summary: "Atenção",
                                    detail: 'Etiqueta enviada para o servidor de impressão.',
                                    life: 3000
                                });

                            }


                            $('#printPreviewModal').modal('hide');

                        } else {

                            let blob = new Blob([response.data], { type: 'application/pdf' }),
                                url = window.URL.createObjectURL(blob)


                            this.iframe_src = url;

                        }
                        */
                    })
                    .catch(error => { 
                        this.$toast.add({
                            severity: 'error',
                            summary: "Atenção",
                            detail: ( error.response && error.response.data ) ? error.response.data.message : error.message,
                            life: 3000
                        });

                        $('#printPreviewModal').modal('hide');
                    })
                    .finally(() => { 
                        this.$store.commit('loading', false);
                    });

            }

            
        }
    },

    mounted() { 
        this.$util.set_print_modal_function(this.imprimir);
    }
}
</script>